import React, { Fragment, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import cl from 'classnames';

import 'react-loading-skeleton/dist/skeleton.css';

import { ClassName } from '../../types';

interface LoadingProps {
  addClass?: string;
  children?: ReactNode;
  className?: string;
  skeletonClassName?: ClassName;
  itemClassName?: ClassName;
  ignoreLoader?: ReactNode;
  count?: number;
  loaded?: boolean;
  withoutLoader?: boolean;
  width?: string | number;
  height?: string | number;
  inline?: boolean;
}

function LoadingSkeleton({
  addClass,
  children,
  className,
  skeletonClassName,
  itemClassName,
  ignoreLoader,
  count = 7,
  loaded = false,
  withoutLoader = false,
  width,
  height,
  inline
}: LoadingProps) {
  if (!loaded && withoutLoader) {
    return null;
  }

  return (
    <Fragment>
      {ignoreLoader}
      {loaded ? (
        children
      ) : (
        <div className={className || cl('m-4', addClass)}>
          <Skeleton
            count={count}
            height={height}
            width={width}
            containerClassName={skeletonClassName}
            className={itemClassName}
            inline={inline}
          />
        </div>
      )}
    </Fragment>
  );
}

export default LoadingSkeleton;
